var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"text":"","prominent":"","type":_vm.msgtype}},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }